import React from 'react'
import { observer, inject } from 'mobx-react'
import { StateType } from '../state/state'
import { CountryMultiSelect } from './CountryMultiSelect'
import { ChallengesButtons } from './ChallengesButtons'
import { RegionsButtons } from './RegionsButtons'
import { DataTypeToggles } from './DataTypeToggles'
import { YearsSlider } from './YearsSlider'

interface Props {
  className?: string
  state?: StateType
}

export const ControlPanel: React.FC<Props> = inject('state')(
  observer(({ className = '', state }) => {
    const { debug } = state.ScatterplotState

    return (
      <div className={`-control-panel h-100 pt3 pb3 pl3 overflow-y-auto ${className}`}>
        <Container className="" debug={debug}>
          <ChallengesButtons className="" />
        </Container>

        <Container className="" debug={debug}>
          <YearsSlider className="" />
        </Container>

        <Container className="" debug={debug}>
          <CountryMultiSelect className="" />
        </Container>

        <Container className="" debug={debug}>
          <RegionsButtons className="" />
        </Container>

        <Container className="" debug={debug}>
          <DataTypeToggles className="" />
        </Container>
      </div>
    )
  })
)

interface ContainerProps {
  className?: string
  debug: boolean
  children?: React.ReactNode
}

const Container: React.FC<ContainerProps> = ({ className = '', debug, children }) => {
  return (
    <div className={`w-100 ${debug ? 'ba' : ''} ${className}`} style={{ marginBottom: '2.4rem' }}>
      {children}
    </div>
  )
}
